<template>
  <b-container>
    <b-row class="justify-content-center">
      <slot name="p-1"></slot>
    </b-row>

    <b-row class="justify-content-center" v-if="getPosts != null"> </b-row>
    <p class="col-12 d-flex flex-wrap">
      <b-col
        lg="4"
        md="12"
        sm="12"
        class="mb-0 p-0"
        v-for="post in getPosts"
        :key="post.id"
      >
        <m-c512 :image="post.thumbnail" :alt="post.title">
          <template #p-1>
            <h5 class="text-512-p px-3 my-2">{{ post.title }}</h5>

            <div
              v-html="post.abstraction.slice(0, 50)"
              class="text-muted mb-0 px-3"
            ></div>
          </template>
          <template  #pr-1>
   
            <div class="mt-2 mr-3">
            <router-link
              v-for="category in post.category"
              :key="category.id"
              :to="{}"
            >
               <m-bt501 class='m-1'>{{ category.name }}</m-bt501>
            </router-link>
            </div>
          </template>

          <template #p-2>
            <h6 md="12" sm="12" class="col-lg-6 col-sm-12 col-md-12 px-3">
              <span class="mt-2 mr-3 d-block text-danger">
                <b-icon icon="calendar2-week" class="ml-2" />{{
                  dateConverter(post.created_at)
                }}</span
              >
            </h6>
            <b-col lg="6" md="12" sm="12" class="text-center">
              <router-link
                :to="{ name: 'SinglePost', params: { slug: post.slug } }"
              >
                <b-button
                  class="border-0 text-muted font-weight-bold text-center"
                  variant="transparent"
                >
                  <p class="text-danger text-muted">ادامه مطلب</p>
                </b-button>
              </router-link>
            </b-col>
          </template>
        </m-c512>
      </b-col>
    </p>

    <b-row>
      <div class="ml-auto mr-auto">
        <m-pagination-400
          v-if="havePagination"
          :meta="paginationMeta"
          :on-change-page="changePage"
        />
      </div>
      <slot name="p-2" />
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
import { dateConverter } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Pagination from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/dashboard/Pagination.vue";

export default {
  name: "Posts400",
  props: ["showNumber", "havePagination"],
  components: { Pagination },
  computed: {
    ...mapGetters({
      posts: "Content/getContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
    getPosts() {
      if (this.showNumber) {
        const posts = this.posts;
        return posts.slice(0, this.showNumber);
      } else {
        return this.posts;
      }
    },
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Content/getContents", { type: "post", page: page });
      router.push({
        name: "Posts",
        query: { ...router.currentRoute.query, page: page },
      });
    },
    dateConverter(date) {
      return dateConverter(date, "/");
    },
  },
  async mounted() {
    await this.$store.dispatch("Content/getContents", {
      type: "post",
      page: 1,
    });
  },
};
</script>

<style scoped>
.card .card-img-top {
  border-radius: 15px 15px 0 0;
}

.card {
  height: 100% !important;
  cursor: pointer;
}

.img-object-fit {
  object-fit: cover;
}
.card-body {
  padding: 0;
}
</style>
